import styled from 'styled-components/macro';

interface IQuestionWrapperProps {
  index: number;
}

const QuestionWrapper = styled.div<IQuestionWrapperProps>`
  width: 100%;
  padding: 40px 20px;
  background-color: ${(props): string => (props.index % 2 === 0 ? 'white;' : 'transparent')};
`;

export default QuestionWrapper;
